export default {

  init() {

    $( document ).on( 'click', '.js-nav-toggle', this.toggleMobileNav );
    $( document ).on( 'click', '.js-nav-link', this.closeOnClick );

  },

  toggleMobileNav( event ) {

    const $el = $( event.currentTarget );

    if ( $el.hasClass( 'is-nav-open' ) ) {

      $el.removeClass( 'is-nav-open' ).parents( '.js-nav-container' ).removeClass( 'is-nav-open' ).addClass( 'is-nav-unloading' );
      setTimeout( () => {
        $el.parents( '.js-nav-container' ).removeClass( 'is-nav-unloading' );
      }, 300);

    } else {

      $el.addClass( 'is-nav-open' ).parents( '.js-nav-container' ).addClass( 'is-nav-loading' );
      setTimeout( () => {
        $el.parents( '.js-nav-container' ).removeClass( 'is-nav-loading' ).addClass( 'is-nav-open' );
      }, 300);
    }

  },

  closeOnClick( event ) {

    $( event.currentTarget ).parents( '.js-nav-container' ).removeClass( 'is-nav-open' ).find( '.js-nav-toggle' ).removeClass( 'is-nav-open' );

  },

}



// WEBPACK FOOTER //
// ./scripts/modules/nav.js